// extracted by mini-css-extract-plugin
export default {"ag-styles":"k_M","policyPage":"k_Z","introduction":"k_0","policyList":"k_1","settingsButton":"k_2"};